import React from 'react';
import FormTextInput from '../../common/utility/FormTextInput';
import FormCaptchaField from '../../common/utility/FormCaptchaField';
import FormOffers from '../../common/FormOffers';
import FormPolicy from '../../common/FormPolicy';
import FormConsentDetails from '../../common/FormConsentDetails';
import FormSelectField from '../../common/utility/FormSelectField';
import FormDateField from '../../common/utility/FormDateField';
import FormMultipleInterests from '../../common/FormMultipleInterests';
import FormContactInfo from '../../common/FormContactInfo';
import FormCheckboxInput from '../../common/utility/FormChecboxInput';
import FormLookupField from '../../common/utility/FormLookupField';
import FormHTML from '../../common/utility/FormHTML';
import FormMobilePhoneInput from '../../common/utility/FormMobilePhoneInput';
import FormMastercardField from '../../common/utility/FormMastercardField';
import FormTextAndImageField from '../../common/utility/FormTextAndImageField';

export const formFields = {
    /* eslint-disable */
    text: (fieldProperties) => {
        return <FormTextInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            autocompleteValue={fieldProperties.autocompleteValue}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            size={fieldProperties.fieldSize}
            isPassword={fieldProperties.isPassword}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
            isDisabled={fieldProperties.isDisabled}
            tooltipText={fieldProperties.tooltipText}
        ></FormTextInput>
    },
    emailAddress: (fieldProperties) => {
       return <FormTextInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            autocompleteValue={fieldProperties.autocompleteValue}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            size={fieldProperties.fieldSize}
            isPassword={fieldProperties.isPassword}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.handleOnBlur}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
            isDisabled={fieldProperties.isDisabled}
            tooltipText={fieldProperties.tooltipText}
        ></FormTextInput>
    },
    username: (fieldProperties) => formFields['text'](fieldProperties),
    confirmEmailAddress: (fieldProperties) => formFields['text'](fieldProperties),
    oldPassword: (fieldProperties) => {
        fieldProperties['isPassword'] = true;
        return formFields['text'](fieldProperties);
    },
    password: (fieldProperties) => {
        fieldProperties['isPassword'] = true;
        return formFields['text'](fieldProperties);
    },
    confirmPassword: (fieldProperties) => {
        fieldProperties['isPassword'] = true;
        return formFields['text'](fieldProperties);
    },
    title: (fieldProperties) => {
        return <FormSelectField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            isDisabled={fieldProperties.isDisabled}
            defaultValue={fieldProperties.defaultValue}
            size={fieldProperties.fieldSize}
            options={fieldProperties.fieldOptions}
            propertyForValue={fieldProperties.propertyForValue}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormSelectField >
    },
    firstName: (fieldProperties) => formFields['text'](fieldProperties),
    lastName: (fieldProperties) => formFields['text'](fieldProperties),
    dateOfBirth: (fieldProperties) => {
        return <FormDateField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isDisabled={fieldProperties.isDisabled}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            onChange={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormDateField>
    },
    addressLine1: (fieldProperties) => formFields['text'](fieldProperties),
    addressLine2: (fieldProperties) => formFields['text'](fieldProperties),
    addressLine3: (fieldProperties) => formFields['text'](fieldProperties),
    postcode: (fieldProperties) => formFields['text'](fieldProperties),
    mobilePhone: (fieldProperties) => {
        return <FormMobilePhoneInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            autocompleteValue={fieldProperties.autocompleteValue}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isDisabled={fieldProperties.isDisabled}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            countries={fieldProperties.fieldOptions}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}></FormMobilePhoneInput>
    },
    city: (fieldProperties) => formFields['text'](fieldProperties),
    country: (fieldProperties) => {
        return <FormSelectField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isDisabled={fieldProperties.isDisabled}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            options={fieldProperties.fieldOptions}
            propertyForValue={fieldProperties.propertyForValue}
            onChange={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormSelectField >
    },
    county: (fieldProperties) => {
        const { fieldOptions } = fieldProperties;
        return fieldOptions !== undefined && fieldOptions.length > 0 ? (<FormSelectField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            isDisabled={fieldProperties.isDisabled}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            options={fieldProperties.fieldOptions}
            propertyForValue={fieldProperties.propertyForValue}
            onChange={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormSelectField>) : null
    },
    state: (fieldProperties) => {
        const { fieldOptions } = fieldProperties;
        return fieldOptions !== undefined && fieldOptions.length > 0 ? (<FormSelectField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isDisabled={fieldProperties.isDisabled}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            options={fieldProperties.fieldOptions}
            propertyForValue={fieldProperties.propertyForValue}
            onChange={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormSelectField>) : null
    },
    mainAddress: (fieldProperties) => {
        return <FormCheckboxInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            onChange={fieldProperties.fieldChangeCallback}
        ></FormCheckboxInput>
    },
    shippingAddress: (fieldProperties) => {
        return <FormCheckboxInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            onChange={fieldProperties.fieldChangeCallback}
        ></FormCheckboxInput>
    },
    billingAddress: (fieldProperties) => {
        return <FormCheckboxInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            onChange={fieldProperties.fieldChangeCallback}
        ></FormCheckboxInput>
    },
    favoritePlayer: (fieldProperties) => {
        return <FormLookupField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            suggestions={fieldProperties.fieldSuggestions}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}></FormLookupField>
    },
    venues: (fieldProperties) => {
        return <FormMultipleInterests
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            interestsData={fieldProperties.interestsData}
            defaultValue={fieldProperties.defaultValue}
            name={fieldProperties.name}
            onChange={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormMultipleInterests>
    },
    consent: (fieldProperties) => {
        return <FormConsentDetails
            key={fieldProperties.fieldName}
            defaultValue={fieldProperties.defaultValue}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            consentDetails={fieldProperties.consentDetails}
        ></FormConsentDetails>
    },
    offersDetails: (fieldProperties) => {
        return <FormOffers
            key={fieldProperties.fieldName}
            offersDetails={fieldProperties.offersDetails}
            refuseOffersName={fieldProperties.refuseOffersName}
            acceptOffersName={fieldProperties.acceptOffersName}
            isDisabled={fieldProperties.isDisabled}
            defaultValue={fieldProperties.defaultValue}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            onChange={fieldProperties.fieldChangeCallback}
        ></FormOffers>
    },
    privacyPolicy: (fieldProperties) => {
        return <FormPolicy
            key={fieldProperties.fieldName}
            policy={fieldProperties.policy}
            consentLabel={fieldProperties.consentLabel}
            showConsent={fieldProperties.showConsent}
            defaultValue={fieldProperties.defaultValue}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            policyName={fieldProperties.fieldName}
            onChange={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormPolicy>
    },
    oneClubTermsAndServices: (fieldProperties) => formFields['privacyPolicy'](fieldProperties),
    contactDetails: (fieldProperties) => {
        return <FormContactInfo
            key={fieldProperties.fieldName}
            defaultValue={fieldProperties.defaultValue}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            contactDetails={fieldProperties.contactDetails}
        ></FormContactInfo>
    },
    verificationCode: (fieldProperties) => {
        return <FormTextInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            isPassword={fieldProperties.isPassword}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.fieldChangeCallback}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}></FormTextInput>;
    },
    becomeOneClubMember: (fieldProperties) => {
        return <FormCheckboxInput
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            onChange={fieldProperties.fieldChangeCallback}
        ></FormCheckboxInput>
    },
    becomeOneClubMemberInfo: (fieldProperties) => {
        return <FormHTML
            fieldName={fieldProperties.fieldName}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            textClassName={'text-info'}>
        </FormHTML>
    },
    mainAddressLabel: (fieldProperties) => {
        return <FormHTML
            fieldName={fieldProperties.fieldName}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            textClassName={'text-info'}>
        </FormHTML>
    },
    championshipSection: (fieldProperties) => formFields['venues'](fieldProperties),
    channelSection: (fieldProperties) => formFields['venues'](fieldProperties),
    interestSection: (fieldProperties) => formFields['venues'](fieldProperties),
    raMemberId: (fieldProperties) => formFields['text'](fieldProperties),
    reCaptcha: (fieldProperties) => {
        return <FormCaptchaField
        key={fieldProperties.fieldName}
        formRef={fieldProperties.formReference}
        name={fieldProperties.fieldName}
        isHidden={fieldProperties.isHidden}
        onChange={fieldProperties.fieldChangeCallback}
        validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
        ></FormCaptchaField>
        },
    mastercard: (fieldProperties) => {
    return <FormMastercardField
            key={fieldProperties.fieldName}
            formRef={fieldProperties.formReference}
            name={fieldProperties.fieldName}
            autocompleteValue={fieldProperties.autocompleteValue}
            label={fieldProperties.fieldLabel}
            headerTitle={fieldProperties.fieldHeaderTitle}
            headerText={fieldProperties.fieldHeaderText}
            isHidden={fieldProperties.isHidden}
            defaultValue={fieldProperties.defaultValue}
            size={fieldProperties.fieldSize}
            isPassword={fieldProperties.isPassword}
            onChange={fieldProperties.fieldChangeCallback}
            onBlur={fieldProperties.handleOnBlur}
            validState={fieldProperties.fieldValidStateCallback(fieldProperties.fieldName)}
            isDisabled={fieldProperties.isDisabled}
            tooltipText={fieldProperties.tooltipText}
            mastercardLogo={fieldProperties.mastercardLogo}
        ></FormMastercardField>
    },
    textAndImageTile: (fieldProperties) => {
        return <FormTextAndImageField
                    key={fieldProperties.fieldName}
                    formRef={fieldProperties.formReference}
                    headerTitle={fieldProperties.fieldHeaderTitle}
                    headerText={fieldProperties.fieldHeaderText}
                    imageSrc={fieldProperties.imageSrc}
                    tag={fieldProperties.tag}
            ></FormTextAndImageField>
    }
    /* eslint-enable */
};
